import * as React from "react";
import { cn } from "../../../helpers";
import styles from "./RadioInput.module.scss";

export interface RadioInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    /** Radio label text */
    label: React.ReactNode;
    /** Additional wrapper styles */
    wrapperClass?: string;
    /** Additional label styles */
    labelClass?: string;
    /** Disable the radio input */
    disabled?: boolean;
    /** Error state */
    error?: boolean;
    /** Helper text */
    helperText?: string;
}

const RadioInput = React.forwardRef<HTMLInputElement, RadioInputProps>(
    (
        {
            label,
            name,
            id,
            wrapperClass,
            labelClass,
            disabled = false,
            error = false,
            helperText,
            className,
            ...props
        },
        ref
    ) => {
        const radioId = id;

        return (
            <div
                className={cn(
                    styles.radioWrapper,
                    wrapperClass,
                    disabled && styles.disabled,
                    error && styles.error
                )}
            >
                <label htmlFor={radioId} className={cn(styles.label, labelClass)}>
                    <input
                        className={cn(styles.radioInput, className)}
                        type="radio"
                        id={radioId}
                        name={name}
                        disabled={disabled}
                        {...props}
                        ref={ref}
                    />
                    <span className={styles.radioButton} />
                    <span className={styles.labelText}>{label}</span>
                </label>
            </div>
        );
    }
);

RadioInput.displayName = "RadioInput";

export { RadioInput };
